import axios from 'axios';
import { API_ENDPOINTS } from './endopoints'; // Adjust the path as necessary

class UserService {
  getFilteredUsers(
    page: any,
    limit: any,
    search: any,
    userType: any,
    accountType: any,
    accountStatus: any,
    userActive: any,
    subdomain: any
  ) {
    const url = `${API_ENDPOINTS.getUsers}?page=${page}&limit=${limit}&user_type=${userType}&account_type=${accountType}&account_status=${accountStatus}&active=${userActive}&search=${search}&subdomain=${subdomain}`;
    return axios.get(url, this.getHeaders());
  }

  createUser(user: any) {
    return axios.post(API_ENDPOINTS.createUser, user, this.getHeaders());
  }

  updateUser(id: any, user: any) {
    const url = `${API_ENDPOINTS.updateUser}`;
    return axios.put(url, user, this.getHeaders());
  }

  deleteUser(userId: any) {
    const url = `${API_ENDPOINTS.deleteUser}${userId}`;
    return axios.delete(url, this.getHeaders());
  }
  archiveUser(userId: any) {
    const url = `${API_ENDPOINTS.archiveUser}${userId}`;
    return axios.put(url, null, this.getHeaders());
  }
  getInfomationSubdomain(subdomain: any) {
    const url = `${API_ENDPOINTS.getInfomationSubdomain}${subdomain}`;
    return axios.get(url, this.getHeaders());
  }

  getImageSubmerchant(subdomain: any) {
    const url = `${API_ENDPOINTS.getImageSubmerchant}${subdomain}`;
    return axios.get(url, this.getHeaders());
  }
  createdInvitation(user: any) {
    return axios.post(API_ENDPOINTS.createdInvitation, user, this.getHeaders());
  }
  getIdUser(id: any) {
    const url = `${API_ENDPOINTS.getIdUser}${id}`;
    return axios.get(url, this.getHeaders());
  }
  updateUserInvitation(user: any) {
    return axios.put(API_ENDPOINTS.updateInvitation, user, this.getHeaders());
  }
  getTokenUsed(email: string, token: string) {
    const url = `${API_ENDPOINTS.getTokenUsed}/${token}/${email}`;
    return axios.get(url);
  }
  getInvitation(
    id: number,
    params: {
      page: number;
      limit: number;
      search: string;
      status: boolean;
      sort: string;
      order: string;
    }
  ) {
    const url = `${API_ENDPOINTS.getInvitation}/${id}`;
    return axios.post(url, params); // Cambiado a POST y enviando los params
  }
  updateInvitationUsed(id: number, code: boolean) {
    const url = `${API_ENDPOINTS.updateInvitationUsed}/${id}`;
    return axios.put(`${API_ENDPOINTS.updateInvitationUsed}/${id}`, { code_used: code });
  }
  deleteInvitationGenerated(id: number) {
    const url = `${API_ENDPOINTS.deleteInvitationGenerated}/${id}`;
    return axios.delete(url);
  }

  getHeaders() {
    // Implement logic to get the necessary headers, e.g., authorization token
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
  }
}

export default new UserService();
